var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form",model:{value:(_vm.isFormValid),callback:function ($$v) {_vm.isFormValid=$$v},expression:"isFormValid"}},[(_vm.isSchemaLoaded)?_c('v-form-base',{attrs:{"value":_vm.udf.model,"schema":_vm.udf.schema},on:{"input":_vm.onInput}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }